import Head from './Head'

export default Head
// eslint-disable-next-line import/export
export * from './Head'
